<script setup lang="ts">
import { SolButton } from '@solfacil/girassol'
import { useWalletTabNavigation } from '~/features/my-wallet/composables/useWalletTabNavigation'

interface Props {
  id: string
  tab: string
  label: string
}

const props = defineProps<Props>()

const { goToTab } = useWalletTabNavigation()
</script>

<template>
  <SolButton
    :id="id"
    variant="secondary"
    size="medium"
    class="cross-tab-link"
    @click="goToTab(props.tab)"
  >
    {{ label }}
  </SolButton>
</template>
